import { render, staticRenderFns } from "./ModalCommande.vue?vue&type=template&id=6400a64f&scoped=true"
import script from "./ModalCommande.vue?vue&type=script&lang=js"
export * from "./ModalCommande.vue?vue&type=script&lang=js"
import style0 from "./ModalCommande.vue?vue&type=style&index=0&id=6400a64f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400a64f",
  null
  
)

export default component.exports